import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';

@Component({
  selector: 'app-store-history',
  templateUrl: './store-history.page.html',
  styleUrls: ['./store-history.page.scss'],
})
export class StoreHistoryPage implements OnInit {
  ownerID;
  shopOrders = [];
  shopDetails;

  constructor(
    private router: Router,
    private menu: MenuController,
    private auth: AngularFireAuth,
    private shopService: ShopServiceService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.ownerID = user.uid;
        this.getStore();
      }
    });
  }

  getOrders(store) {
    this.shopService.getShopOrders(store).subscribe((res) => {
      this.shopOrders = res.map((order) => ({
        ...(order.payload.doc.data() as Object),
      }));

      this.shopOrders = this.shopOrders.filter((a) => a.status === 'delivered');

      this.shopOrders = this.shopOrders.sort(
        (a, b) => b.createdAt - a.createdAt
      );

      console.log(this.shopOrders);
    });
  }

  getStore() {
    this.shopService
      .getShopProfile(this.ownerID)
      .pipe(take(1))
      .subscribe((res) => {
        if (res.exists) {
          this.shopDetails = res.data() as Object;
          const { storeName } = this.shopDetails;
          if (storeName) {
            const store = storeName.toLowerCase();
            this.getOrders(store);
          } else {
            alert('Update Store Profile First');
          }
        } else {
          alert('Update Store Profile First');
        }
      });
  }

  openStore(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  storeHome() {
    this.router.navigate(['store-home']);
  }
  orders() {
    this.router.navigate(['store-orders']);
  }
  history() {
    this.router.navigate(['store-history']);
  }
  products() {
    this.router.navigate(['store-view']);
  }

  edit() {
    this.router.navigate(['store-change']);
  }

  logout() {
    this.loginService.logout();
  }
}
